<template>
  <div class="fixed-bottom footer"> 
    <nav class="navbar-expand-sm navbar-dark"> 
      <div class="container-fluid d-flex justify-content-end"> 
        <div>
          <label id="date" class="footer-date">{{ currentDate }}</label>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentDate: this.getFormattedDate()
    };
  },
  methods: {
    getFormattedDate() {
  const dateStr = new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  // Ensure "AM" or "PM" is uppercase
  return dateStr.replace(/\s(am|pm)$/i, (match) => match.toUpperCase());
}

  },
  mounted() {
    // Update the date every second
    setInterval(() => {
      this.currentDate = this.getFormattedDate()
    }, 1000);
  }
};
</script>

<style>
/* Add your styles here */
</style>
